import dot from 'dot-object';

export default {
  computed: {
    hasErr() {
      return this.errorMsg && Object.keys(this.errorMsg).length > 0;
    }
  },
  methods: {
    // Will return first error for specified field, else default value or undefined
    fErr(path, def = undefined) {
      let err = dot.pick(path, this.errorMsg) || def;
      if (!err) {
        err = this.errorMsg[path] ? this.errorMsg[path] : def;
      }
      return Array.isArray(err) && err.length > 0 ? err[0] : err;
    },
    fErrState(path, def = undefined) {
      return this.fErr(path, def) === undefined ? undefined : false;
    },
    fErrA(path, def = []) {
      let err = dot.pick(path, this.errorMsg) || def;
      if (!err) {
        err = this.errorMsg[path] ? this.errorMsg[path] : def;
      }
      return Array.isArray(err) && err.length > 0 ? err : def;
    },
    // Will return first error for specified field, else default value or undefined
    fErrStr(path, def = undefined) {
      let err = dot.pick(path, this.errorMsg) || def;
      if (!err) {
        err = this.errorMsg[path] ? this.errorMsg[path] : def;
      }
      err = Array.isArray(err) && err.length > 0 ? err[0] : err;
      return typeof err === 'string' ? err : def;
    },
    // Will return first error for specified field, else default value or undefined
    fErrObj(path, def = undefined) {
      let err = dot.pick(path, this.errorMsg) || def;
      if (!err) {
        err = this.errorMsg[path] ? this.errorMsg[path] : def;
      }
      err = Array.isArray(err) && err.length > 0 ? err[0] : err;
      return typeof err === 'object' ? err : def;
    },
  }
};
